import * as React from 'react';
import styles from './styles.module.css';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { BackHand, CheckCircle, CheckRounded, Done, DoneAllRounded, NotificationAddRounded, NotificationsActiveRounded, Warning, WarningTwoTone } from '@mui/icons-material';
import { Typography } from '@material-ui/core';
import { BatteryLargeResetOutline } from '@brightlayer-ui/icons-mui';
import { LineDetail } from '../../../types/device';
import { SystemLineZoneStatusENUM } from '../../enum/ENUM';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { TooltipItem } from '../../../components/TooltipItem/TooltipItem';
import { getControlledText } from '../../enum/GenericFormat';

interface Props {
    data: LineDetail;
    click: (record: any) => void
}

export const statusStyleMap: Record<number, string> = {
    [SystemLineZoneStatusENUM.READY]: styles.statusReady,
    [SystemLineZoneStatusENUM.BLOCKED]: styles.statusBlocked,
    [SystemLineZoneStatusENUM.ERROR]: styles.statusError,
    [SystemLineZoneStatusENUM.WARNING]: styles.statusWarning,
    [SystemLineZoneStatusENUM.IN_TEST]: styles.statusInTest,
    [SystemLineZoneStatusENUM.EMERGENCY]: styles.statusEmergency,
    [SystemLineZoneStatusENUM.RESERVE]: styles.statusReserve,
};

export const statusIconMap: Record<number, React.ReactNode> = {
    [SystemLineZoneStatusENUM.BLOCKED]: <BackHand style={{ fontSize: 18 }} />,
    [SystemLineZoneStatusENUM.ERROR]: <NotificationsActiveRounded style={{ fontSize: 18 }} />,
    [SystemLineZoneStatusENUM.WARNING]: <WarningTwoTone style={{ fontSize: 18 }} />,
    [SystemLineZoneStatusENUM.IN_TEST]: <BatteryLargeResetOutline style={{ fontSize: 18 }} />,
    [SystemLineZoneStatusENUM.EMERGENCY]: <WarningTwoTone style={{ fontSize: 18 }} />,
    [SystemLineZoneStatusENUM.READY]: <CheckRounded style={{ fontSize: 18 }} />,
};

const LineHeroCard: React.FunctionComponent<Props> = (props) => {
    const { data, click } = props;
    const icon = statusIconMap[data.bitStatus[0]];
    const { t } = useLanguageLocale();

    return (
        <div
            className={`${styles.lineHeroCard} ${statusStyleMap[data.bitStatus[0]] || ''}`}
            data-testid="line-hero-card"
            onClick={() => { click(data); }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div className={styles.statusCircle}
                    style={{
                        width: 32,
                        height: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {icon && React.cloneElement(icon as React.ReactElement, { className: styles.statusIcon })}
                </div>
                <h3 style={{ margin: 0 }}>{`${t('LINE_ZONE.LINE')} ${data.id}`}</h3>
            </div>
            <TooltipItem
                title={data.name || t('MANAGE_USERS.NOT_APPLICABLE')}
                isTopPlacement={true}
                lenghtLimit={30}
                component={
                    <h4 style={{ margin: 0, fontWeight: 'normal' }}>
                        {getControlledText(data.name || t('MANAGE_USERS.NOT_APPLICABLE'), 30)}
                    </h4>
                }
            />
            <TooltipItem
                title={data.description || t('MANAGE_USERS.NOT_APPLICABLE')}
                isTopPlacement={true}
                lenghtLimit={30}
                component={
                    <h4 style={{ margin: 0, fontWeight: 'normal' }}>
                        {getControlledText(data.description || t('MANAGE_USERS.NOT_APPLICABLE'), 30)}
                    </h4>
                }
            />
            <Typography style={{ margin: 0, fontWeight: 300, fontSize: 14 }}>
                {`${data.luminairesCount} ${t('ATPLUS.ATPLUS_LUMINAIRE')}`}
            </Typography>
        </div>
    );
};

export default LineHeroCard;
